import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "react-query";
//primereact
import { BreadCrumb } from "primereact/breadcrumb";
import { SplitButton } from "primereact/splitbutton";
//components
import Modal from "../../../../components/modal/Modal";
import { getOwner } from "../../../../services/GlobalRoles/getOwner";
import PaymentMethods from "../../../Settings/PaymentMethods/PaymentMethods";
import ModalCreateCurrentAccount from "../../../Settings/CurrentAccount/ModalCreateCurrentAccount";
//context
import { useAppContext } from "../../../../context/AppContext";
import { useFinancialContext } from "../../../../context/FinancialContext";
//hooks
import { useOptionsSelect } from "../../../../hooks/useOptionsSelect";

//components

export const Header = ({
  updatedPayments,
  updatedCurrentAccount,
  handleDateParcel,
  handleDatePayment,
}) => {
  const { selectedCustomers } = useFinancialContext();
  const { permissions } = useAppContext();

  const [payment, setPayment] = useState([]);
  const [currentAccounts, setCurrentAccounts] = useState([]);
  const [visiblePayment, setVisiblePayment] = useState(false);
  const [createAccVisible, setCreateAccVisible] = useState(false);

  const [loading, setLoading] = useState(false);

  const { paymentMethod, currentAccount, refetchAccs } = useOptionsSelect();

  const { data: owners } = useQuery(
    ["owners"],
    () => getOwner(),
    { enabled: !!createAccVisible || !!permissions?.includes("59") });

  useEffect(() => {
    if (currentAccount) {
      const currentAccountSpreadsheet = currentAccount?.map((item) => ({
        label: item.label,

        command: () => updatedCurrentAccount(item.value),
      }));

      setCurrentAccounts(currentAccountSpreadsheet);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentAccount]);

  useEffect(() => {
    if (paymentMethod) {
      const paymentMethodSpreadsheet = paymentMethod?.map((item) => ({
        label: item.label,

        command: () => updatedPayments(item.value),
      }));

      setPayment(paymentMethodSpreadsheet);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentMethod]);

  const dates = [
    {
      label: "Primeira Parcela",
      icon: "fa-solid fa-calendar-minus",
      command: () => handleDatePayment(),
    },
    {
      label: "Vencimento da Parcela",
      icon: "fa-solid fa-calendar-minus",
      command: () => handleDateParcel(),
    },
  ];

  const items = [
    {
      template: () => (
        <Link to={"/financial/accountReceivable"} className="p-breadcrumb-link">
          Recebimento de Parcelas
        </Link>
      ),
    },
  ];
  
  const home = {
    template: () => (
      <Link to={"/dashboard"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  }

  return (
    <div className="row p-0">
      <div className="col-xl-4">
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>
      <div className="col-xl-8 text-end p-0">
        <div className="row justify-content-end pb-3">
          <div className="col-xl-4">
            <SplitButton
              onClick={permissions && permissions.includes("146") ? () => setCreateAccVisible(true) : undefined} //Cadastrar Conta Corrente
              label="Conta Corrente"
              disabled={!selectedCustomers}
              icon="fa-solid fa-money-bills"
              model={currentAccounts}
              rounded
              severity="success"
              className="w-100 pb-2"
            />
          </div>

          <div className="col-xl-5">
            <SplitButton
              onClick={permissions && permissions.includes("157") ? () => setVisiblePayment(true) : undefined} //Cadastrar Forma de Pagamento
              label="Forma de Pagamento"
              disabled={!selectedCustomers}
              icon="fa-solid fa-hand-holding-dollar"
              model={payment}
              rounded
              className="w-100 pb-2"
            />
          </div>
          <div className="col-xl-3">
            <SplitButton
              label="Data"
              disabled={!selectedCustomers}
              icon="fa-solid fa-calendar-week"
              model={dates}
              rounded
              severity="info"
              className="w-100 pb-2"
            />
          </div>
        </div>
      </div>
      <Modal
        dynamicTitle={"Adicionar Forma de Pagamento"}
        visible={visiblePayment}
        onHide={() => setVisiblePayment(false)}
      >
        <PaymentMethods
          financing={true}
          setVisible={setVisiblePayment}
        />
      </Modal>
      <ModalCreateCurrentAccount
        visible={createAccVisible}
        headerModal={"Cadastrar"}
        handleCloseModal={() => setCreateAccVisible(false)}
        setVisible={setCreateAccVisible}
        owners={owners}
        refresh={refetchAccs}
        loadingAccount={setLoading}
      />
    </div>
  );
};
